<h3>Editar perfil</h3>

<div class="col-12">
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <select class="form-control" [(ngModel)]="humanFactor.factor" (ngModelChange)="onProfileChange()">
                    <option  value="Desarrollador">Desarrollador</option>
                    <option  value="Administrador">Administrador</option>
                    <option  value="Negociador">Negociador</option>
                    <option  value="Promotor">Promotor</option>
                    <option  value="Investigador">Investigador</option>
                    <option  value="Especialista">Especialista</option>
                    <option  value="Meticuloso">Meticuloso</option>
                    <option  value="Creativo">Creativo</option>
                </select>
                <span class="help-block text-muted"><small>Seleccionar</small></span>
            </div>
        </div>
    </div>
</div>

<div *ngIf="editor" class="row justify-content-center">
    <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
        <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
        <ngx-editor
          [editor]="editor"
          [(ngModel)]="html"
          [placeholder]="'Escriba su texto...'"
        ></ngx-editor>
        <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveHtml()">Guardar</button>
    </div>
</div>

